/* global mixpanel */
import mock from './mock';
const e = process.env.NODE_ENV === 'test' ? mock : mixpanel;

export default e;



// WEBPACK FOOTER //
// ./src/store/mixpanel/clients.js